const IMAGE_URL = /\.(jpg|jpeg|png|gif|bmp|webp|svg|tiff|heic|avif|ico)($|\?)/i;

// HEIC and TIFF are images, but most browsers can't render them on a printed page.
const NOT_PRINTABLE_IMAGE_URL = /\.(tiff|heic)($|\?)/i;

export function isImageUrl(url: string): boolean {
    return !!url && IMAGE_URL.test(url);
}

export function isPrintableImageUrl(url: string): boolean {
    return isImageUrl(url) && !NOT_PRINTABLE_IMAGE_URL.test(url);
}
